import { events } from "./constants";
import { trackGA4Event } from "./gaHelpers";

export const trackAddNewListingEvent = ({ source }) => {
  const eventName = events.ADD_NEW_LISTING;
  trackGA4Event({
    event: eventName,
    source,
  });
};

export const trackOpenUserMenu = ({ isLoggedIn, hasNotifs }) => {
  const event = events.SHOW_USER_MENU;
  trackGA4Event({
    event,
    loggedIn: isLoggedIn,
    hasNotifs,
  });
};

export const trackCloseUserMenu = () => {
  const event = events.CLOSE_USER_MENU;
  trackGA4Event({
    event,
  });
};

export const trackOpenNotifs = ({ hasNotifs }) => {
  const event = events.OPEN_NOTIFS;
  trackGA4Event({
    event,
    hasNotifs,
  });
};

export const trackOpenUserProfile = ({ source }) => {
  const event = events.OPEN_USER_PROFILE;
  trackGA4Event({
    event,
    source,
  });
};

export const trackOpenRequests = () => {
  const event = events.OPEN_REQUESTS;
  trackGA4Event({
    event,
  });
};

export const trackOpenFavedListings = () => {
  const event = events.OPEN_FAVED_LISTINGS;
  trackGA4Event({
    event,
  });
};

export const trackToggleFavListings = ({ type }) => {
  const event = events.TOGGLE_FAV_LISTINGS;
  trackGA4Event({
    event,
    type,
  });
};

export const trackOpenContactUs = ({ source }) => {
  const event = events.OPEN_CONTACT_US;
  trackGA4Event({
    event,
    source,
  });
};

export const trackToggleContactUs = ({ type }) => {
  const event = events.TOGGLE_CONTACT_US;
  trackGA4Event({
    event,
    type,
  });
};

export const trackSubmitContactUs = (options) => {
  const event = events.SUBMIT_CONTACT_US;
  trackGA4Event({
    event,
    ...options,
  });
};

export const trackCloseServicesPopup = () => {
  const event = events.CLOSE_POPUP_SERVICE;
  trackGA4Event({
    event,
  });
};

export const trackOpenBuildingCalculator = () => {
  const event = events.OPEN_BUILDING_CALCULATOR;
  trackGA4Event({
    event,
  });
};

export const trackOpenAddFeatured = () => {
  const event = events.OPEN_ADD_FEATURED;
  trackGA4Event({
    event,
  });
};

export const trackOpenServices = () => {
  const event = events.OPEN_SERVICES;
  trackGA4Event({
    event,
  });
};

export const trackOpenRentContracts = () => {
  const event = events.OPEN_RENT_CONTRACTS;
  trackGA4Event({
    event,
  });
};

export const trackOpenStats = () => {
  const event = events.OPEN_STATS;
  trackGA4Event({
    event,
  });
};

export const trackOpenConstruction = () => {
  const event = events.OPEN_CONSTRUCTION;
  trackGA4Event({
    event,
  });
};

export const trackOpenReportListingModal = () => {
  const event = events.OPEN_REPORT_LISTING_MODAL;
  trackGA4Event({
    event,
  });
};

export const trackSubmitListingReport = ({ id, content, reason }) => {
  const event = events.SUBMIT_LISTING_REPORT;
  trackGA4Event({
    event,
    listing_id: id,
    content,
    reason,
  });
};

export const trackOpenPropertyRegistration = () => {
  const event = events.OPEN_PROPERTY_REGISTRATION;
  trackGA4Event({
    event,
  });
};

export const trackOpenSurveyingProperty = () => {
  const event = events.OPEN_SURVEYING_PROPERTY;
  trackGA4Event({
    event,
  });
};

export const trackOpenListingsFee = () => {
  const event = events.OPEN_LISTING_FEE;
  trackGA4Event({
    event,
  });
};

export const trackDailyRentMode = () => {
  const event = events.DAILY_RENT_MODE;
  trackGA4Event({
    event,
  });
};

export const trackDailyRentReserve = (formattedListing) => {
  const event = events.DAILY_RENT_RESERVE;
  trackGA4Event({
    event,
    ...formattedListing,
  });
};
